import { SummaryIcon, ChangeButton } from '~/components'
import classnames from 'classnames/bind'
import * as common from '~/config/common.module.css'
import * as styles from './index.module.css'

const cx = classnames.bind(common)

export default function BookingSummaryField({ title, value, icon, changeToggle, required, empty }) {
  return (
    <div className={styles.group}>
        <div className={styles.groupIcon}>
            <SummaryIcon id={icon}></SummaryIcon>
        </div>
        <div className={styles.groupContent}>
            <div className={styles.groupContentColumn}>
                <div className={styles.groupContentMainColumn}>
                    <div className={common.title}>{title}</div>
                    <div className={cx(common.subtitle, {warning: required && empty})}>{value}</div>
                </div>
                {changeToggle && <ChangeButton onClick={() => changeToggle()}/>}
            </div>
        </div>
    </div>
  )
}
